import {Department} from '../models/middleware';

/**
 * The synthetic "View All" sub-department: `shop/categories/:department/view-all`. Its own
 * module, free of stores, so BrandHeader can navigate with it without importing linking.ts.
 */
export const viewAllSubDepartment = (): Department => ({
  id: 'view-all',
  name: 'View All',
  parent: null,
  position: 0,
  promote_at_checkout: false,
  type: 'departments',
  links: {
    icon: null,
  },
});

/**
 * "View All" arrives in two shapes: the synthetic `view-all` sub-department above (URL parser,
 * mega menu Shop All), and DepartmentScreen's tile, which is the department itself renamed
 * `{...department, name: 'View All'}`.
 */
export const isViewAll = (
  department: Pick<Department, 'id'> | undefined,
  subDepartment: Pick<Department, 'id' | 'name'> | undefined,
): boolean =>
  subDepartment?.id === 'view-all' ||
  (subDepartment?.name === 'View All' && subDepartment.id === department?.id);
